// src/features/files/components/FileThumbnail.jsx
// Small square preview of a file: the image itself (via a signed link, so
// protected files work too) or the file-type icon.
import React, { useState } from 'react';
import { Avatar, Box } from '@mui/material';
import { useFileUrl } from '../hooks/useFileUrl';
import { supportsPreview } from '../utils/supportsPreview';
import { getFileIcon } from '../utils/getFileIcon';
import { getFileIconColor } from '../utils/getFileTypeColor';

export default function FileThumbnail({ fileId, filetype, filename, size = 32, previewSize = '32x32', sx }) {
  const [failed, setFailed] = useState(false);
  const previewable = supportsPreview(filetype) && !failed;
  const { url } = useFileUrl(previewable ? fileId : null, { size: previewSize });

  if (previewable && url) {
    return (
      <Box
        component="img"
        src={url}
        alt={filename}
        onError={() => setFailed(true)}
        sx={{ width: size, height: size, objectFit: 'cover', borderRadius: 0.5, border: '1px solid', borderColor: 'divider', cursor: 'pointer', ...sx }}
      />
    );
  }
  return (
    <Avatar sx={{ width: size, height: size, bgcolor: 'transparent', color: getFileIconColor(filetype), cursor: 'pointer', ...sx }}>
      {getFileIcon(filetype)}
    </Avatar>
  );
}
